import { create } from 'zustand'

const initialLoadingState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errorMessage: null
}

export const useLoadingStore = create<ILoadingStore>(set => ({
  ...initialLoadingState,
  startLoading: () =>
    set(state => {
      return {
        ...state,
        isLoading: true,
        isSuccess: false,
        isError: false
      }
    }),
  finishWithSuccess: () =>
    set(state => {
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
        isError: false
      }
    }),
  finishWithError: errorMessage => {
    set(state => {
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        errorMessage: errorMessage || null
      }
    })
  },

  resetLoading: () =>
    set(state => {
      return {
        ...state,
        ...initialLoadingState
      }
    })
}))

export interface ILoadingStore {
  isLoading: boolean
  isSuccess: boolean
  isError: boolean
  errorMessage: string | null
  startLoading: () => void
  finishWithSuccess: () => void
  finishWithError: (errorMessage?: string) => void
  resetLoading: () => void
}
